import React from "react";
import { HomeIcon } from "../../assets";
const MeasureNavigation = () => {
  return (
    <div className="content-nav">
      <img src={HomeIcon} />
      <span className="content-nav-home">Home</span>
      <i class="bx bx-chevron-right"></i>
      <span className="content-nav-home">Measurement</span>
    </div>
  );
};

export default MeasureNavigation;
